var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeWork = function SvgHomeWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "homeWork_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#homeWork_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.167 7.5h1.666V5.833h-1.666V7.5Zm0 3.333h1.666V9.167h-1.666v1.666Zm0 3.334h1.666V12.5h-1.666v1.667ZM17.5 17.5H15a.807.807 0 0 1-.594-.24.806.806 0 0 1-.24-.593c0-.236.08-.434.24-.594.16-.16.358-.24.594-.24h2.5V4.167H10v1.166L8.333 4.125c0-.444.16-.826.48-1.146.319-.32.7-.479 1.145-.479H17.5c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177v11.666c0 .459-.164.851-.49 1.177-.326.327-.719.49-1.177.49Zm-15 0c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177v-5.812a1.622 1.622 0 0 1 .709-1.354l4.166-2.98c.292-.208.611-.312.959-.312.347 0 .666.104.958.313l4.167 2.979a1.616 1.616 0 0 1 .708 1.354v5.812c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49h-2.5a.806.806 0 0 1-.593-.24.806.806 0 0 1-.24-.593v-3.334H5.833v3.334c0 .236-.08.434-.24.593A.806.806 0 0 1 5 17.5H2.5Zm0-7.5v5.833h1.667V12.5c0-.236.08-.434.24-.594.159-.16.357-.24.593-.24h3.333c.236 0 .434.08.594.24.16.16.24.358.24.594v3.333h1.666V10L6.667 7.042 2.5 10Z",
    fill: "#40424C"
  }))));
};
export default SvgHomeWork;